

















































import Vue, { PropOptions } from 'vue';
interface IOption { id: number | string; value: number | string; text: string; }

export default Vue.extend({
  name: 'KintaiSearchableSelect',
  props: {
    value: [String, Number],
    options: Array as PropOptions<IOption[]>,
    placeholder: { type: String, default: '選択してください' },
  },
  data() {
    return {
      open: false,
      focusedIndex: -1,
      touched: false,
      inputValue: '' as string, // 表示欄 & 検索文字列
    };
  },
  computed: {
    isEmpty(): boolean {
      return this.value === '' || this.value == null;
    },
    selectedOption(): IOption | undefined {
      if (!this.options || this.options.length === 0) {
        return undefined;
      }
      return this.options.find((o) => this.isSelected(o));
    },
    // 入力値で絞り込んだ候補
    filteredOptions(): IOption[] {
      const opts = (this.options as IOption[]) || [];
      const kw = (this.inputValue || '')
        .toString()
        .trim()
        .toLowerCase();
      if (!kw) {
        return opts;
      }
      return opts.filter((o) =>
        String(o.text)
          .toLowerCase()
          .includes(kw),
      );
    },
    focusedId(): string | number {
      const opts = this.filteredOptions;
      return opts && opts[this.focusedIndex] ? opts[this.focusedIndex].id : '';
    },
  },
  watch: {
    value() {
      this.syncInputWithSelected();
    },
    options() {
      this.syncInputWithSelected();
    },
  },
  mounted() {
    this.syncInputWithSelected();
    document.addEventListener('click', this.onDocumentClick, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick, true);
  },
  methods: {
    syncInputWithSelected() {
      const opt = this.selectedOption;
      this.inputValue = opt ? String(opt.text) : '';
    },

    isSelected(o: IOption): boolean {
      return o.value === this.value;
    },
    openMenu() {
      this.open = true;
      const opts = this.filteredOptions;
      const idx = opts.findIndex((o) => this.isSelected(o)); // なければ -1
      this.focusedIndex = idx >= 0 ? idx : opts.length ? 0 : -1;
      this.$nextTick(() => this.ensureInView());
    },
    closeMenu(revertInput = true) {
      this.open = false;
      if (revertInput) {
        // 入力中の文字は捨てて、選択済みのラベルに戻す
        this.syncInputWithSelected();
      }
    },
    onSelect(o: IOption) {
      this.touched = true;
      const v = o.value;
      this.$emit('input', v); // v-model 更新
      this.inputValue = String(o.text);
      this.closeMenu(false);
      const input = this.$refs.input as HTMLInputElement | null;
      if (input) {
        input.focus();
      }
    },
    onInputFocus() {
      if (!this.open) {
        this.openMenu();
      }
    },
    onInputChange(e: Event) {
      const target = e.target as HTMLInputElement;
      this.inputValue = target.value;
      if (!this.open) {
        this.openMenu();
      } else {
        const opts = this.filteredOptions;
        this.focusedIndex = opts.length ? 0 : -1;
        this.$nextTick(() => this.ensureInView());
      }
    },
    onInputKeydown(e: KeyboardEvent) {
      const opts = this.filteredOptions;
      const max = opts.length - 1;

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (!this.open) {
            this.openMenu();
          } else if (max >= 0) {
            this.focusedIndex =
              this.focusedIndex < 0 ? 0 : Math.min(max, this.focusedIndex + 1);
            this.ensureInView();
          }
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (max >= 0) {
            this.focusedIndex =
              this.focusedIndex < 0 ? max : Math.max(0, this.focusedIndex - 1);
            this.ensureInView();
          }
          break;
        case 'Enter':
          if (this.open) {
            e.preventDefault();
            if (opts && opts[this.focusedIndex]) {
              this.onSelect(opts[this.focusedIndex]);
            }
          }
          break;
        case 'Escape':
          e.preventDefault();
          this.closeMenu(true);
          break;
        case 'Tab':
          this.closeMenu(true);
          break;
      }
    },
    ensureInView() {
      const menu = this.$refs.menu as HTMLElement | undefined;
      const opts = this.filteredOptions;
      const current =
        opts && opts[this.focusedIndex] ? opts[this.focusedIndex] : null;
      const item =
        (menu && current && menu.querySelector(`#opt-${current.id}`)) || null;

      if (menu && item) {
        const mTop = menu.scrollTop;
        const mBottom = mTop + menu.clientHeight;
        const iTop = (item as HTMLElement).offsetTop;
        const iBottom = iTop + (item as HTMLElement).offsetHeight;
        if (iTop < mTop) {
          menu.scrollTop = iTop;
        } else if (iBottom > mBottom) {
          menu.scrollTop = iBottom - menu.clientHeight;
        }
      }
    },
    onDocumentClick(e: MouseEvent) {
      if (!this.open) {
        return;
      }
      if (!this.$el.contains(e.target as Node)) {
        this.closeMenu(true);
      }
    },
  },
});
